// Student-facing copy for the error slugs the `postlab.*` routers throw. It
// lives in lib, not in the feature, because the app-wide query error toast
// reads it too.
import type { PostlabErrorSlug } from "@immi/api/postlab-constants"

export const LINKEDIN_TOO_LONG =
  "O LinkedIn aceita até 3.000 caracteres. Encurte o texto antes de publicar."

const TOO_MANY_IN_A_ROW =
  "Você usou muitas vezes seguidas. Tente de novo em alguns minutos."

/**
 * Student-facing copy for the slugs the `postlab.*` routers throw. A slug
 * missing here falls back to the caller's generic message: a raw slug never
 * reaches the screen.
 */
export const POSTLAB_ERROR_COPY: Partial<Record<PostlabErrorSlug, string>> = {
  no_access: "O PostLab não está liberado para a sua conta.",
  interview_incomplete: "Termine o seu posicionamento antes.",
  no_profile: "Termine o seu posicionamento antes.",
  post_not_found: "Esse post não existe mais.",
  review_not_found: "Essa análise não existe mais. Analise de novo.",
  session_not_found: "Essa conversa não existe mais. Comece outra.",
  engine_unavailable:
    "A Lia está fora do ar agora. Tente de novo em alguns minutos.",
  linkedin_unavailable: "A conexão com o LinkedIn está fora do ar agora.",
  impersonation_forbidden: "Só o próprio aluno pode fazer isso.",
  quota_exceeded: "Você usou suas análises deste período.",
  review_budget_reached:
    "Você usou os ajustes desta análise. Edite o texto e analise de novo.",
  turn_in_progress:
    "Essa mensagem ainda está sendo processada. Tente de novo em instantes.",
  processing:
    "Essa mensagem ainda está sendo processada. Tente de novo em instantes.",
  assist_limit: TOO_MANY_IN_A_ROW,
  pdf_limit: TOO_MANY_IN_A_ROW,
  ideas_limit: TOO_MANY_IN_A_ROW,
  help_limit: "Você chegou no limite de perguntas deste post por hoje.",
  already_written: "O post já tem texto seu: a Lia não escreve por cima.",
  not_a_draft: "Esse post já passou do rascunho: a Lia não escreve por cima.",
  posted_immutable: "Post publicado não muda mais por aqui.",
  content_required: "Escreva o texto antes.",
  content_too_long: LINKEDIN_TOO_LONG,
  review_required: "Só post revisado e com texto pode ir pro LinkedIn.",
  too_large: "O arquivo é grande demais.",
  not_pdf: "Envie o PDF que o LinkedIn gera em Salvar em PDF.",
  not_linkedin_profile:
    "Esse PDF não parece ser o perfil do LinkedIn. Use Salvar em PDF no seu perfil.",
  no_suggestion: "A Lia não conseguiu sugerir agora. Tente de novo.",
  no_idea: "A Lia não conseguiu organizar a ideia. Conte de outro jeito.",
  no_reply: "Não consegui responder agora. Tente de novo.",
}

/** The pt-BR copy for a PostLab error slug, or null when it is not one. */
export function postlabErrorCopy(message: string): string | null {
  return POSTLAB_ERROR_COPY[message as PostlabErrorSlug] ?? null
}
